<template>
  <div
    class="tw-relative tw-flex tw-h-36 tw-w-full tw-flex-col tw-justify-between tw-rounded-sm tw-bg-white tw-p-6"
  >
    <cl-heading class="tw-flex tw-items-center" :size="'h6'">
      <slot name="title">
        <div
          v-if="props.href.icon"
          v-tippy="props.tippy"
          class="tw-mr-2 tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-place-self-center tw-rounded-full tw-border-2 tw-border-primary-grey-100 tw-bg-white tw-p-0.5"
        >
          <component :is="props.href.icon" />
        </div>
        <a
          class="tw-text-lg tw-font-semibold tw-text-primary-grey-800 hover:tw-text-primary-grey-800"
          :href="props.href.url"
          :data-test-id="props.testId"
          @mouseover="hoverEvent(true)"
          @mouseleave="hoverEvent(false)"
          @click="props.href.navigate"
        >
          {{ props.href.title }}
        </a>
      </slot>
      <ClIconTablerChevronRight
        v-if="!slots['title']"
        :class="
          hoverState ? 'tw-text-primary-grey-800' : 'tw-text-primary-grey-800'
        "
        class="tw-ml-1 tw-inline tw-min-w-5"
        :width="'20'"
        :height="'20'"
      />
    </cl-heading>
    <div class="tw-relative tw-grid tw-gap-4" :class="columnClass">
      <div
        class="tw-col-span-1 tw-flex tw-flex-col tw-items-start tw-self-start"
      >
        <cl-skeleton v-if="props.loading" class="tw-w-full">
          <cl-skeleton-row />
        </cl-skeleton>
        <slot v-else name="footer-left"></slot>
      </div>
      <div class="tw-col-span-1 tw-flex tw-flex-col tw-items-end tw-self-end">
        <cl-skeleton v-if="props.loading" class="tw-w-full">
          <cl-skeleton-row :bg="'light'" />
        </cl-skeleton>
        <slot v-else name="footer-right"></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
/**
 * @deprecated
 *
 * Please use `cl-data-card` instead.
 */
import { useSlots, ref, computed } from "vue";
import { ClHeading } from "../heading";
import { ClSkeleton } from "../skeleton";
import { ClIconTablerChevronRight } from "../icons";
import type { CardTrendHref, CardTrendToolTipp } from "./types";

export interface CardTrendProps {
  loading?: boolean;
  href?: CardTrendHref;
  testId: string;
  tippy?: CardTrendToolTipp;
}

const hoverState = ref(false);
const slots = useSlots();
const props = withDefaults(defineProps<CardTrendProps>(), {
  loading: false,
  testId: "",
  tippy: () => ({
    content: "",
    placement: "",
  }),
  href: () => ({
    title: "title",
    url: "nameRoute",
    icon: "",
    navigate: () => {},
  }),
});

function hoverEvent(isHover: boolean) {
  hoverState.value = isHover;
}

const columnClass = computed(() => {
  return slots["footer-left"] && slots["footer-right"] ? "tw-grid-cols-2" : "";
});
</script>
